import { Components, CssVarsTheme, Theme } from "@mui/material";
import * as MUIDataGridLocales from "@mui/x-data-grid-premium/locales";
import TextField from "./TextField";
import Button from "./Button";
import Link from "./Link";
import DataGrid from "./DataGrid";
import Switch from "./Switch";
import Checkbox from "./Checkbox";
import Typography from "./Typography";

const ComponentOverrides = (
  theme: Theme,
  locale: keyof typeof MUIDataGridLocales
): Components<Omit<Theme, "components" | "palette"> & CssVarsTheme> =>
  Object.assign(
    TextField(theme),
    Button(),
    Link(theme),
    DataGrid(theme, locale),
    Switch(),
    Checkbox(),
    Typography()
  );

export default ComponentOverrides;
